module.exports = __webpack_public_path__ + "static/media/cancel.08d914f5.png";